// removed by extract-text-webpack-plugin
module.exports = {"button":"styles--button--MvYqrbeE","text-button":"styles--text-button--2UEkNL-u","textButton":"styles--text-button--2UEkNL-u","button-icon":"styles--button-icon--11c8A_DN","buttonIcon":"styles--button-icon--11c8A_DN"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Button/styles.css
// module id = 1165
// module chunks = 2